<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      flat
      :loading="loading"
    >
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title v-if="!loading"> Sync Cache </v-card-title>
      <v-card-text v-if="!loading">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col
              v-for="item in items"
              :key="item.id"
              cols="12"
            >
              <v-checkbox
                v-model="selected"
                class="pt-0 mt-0"
                :value="item.id"
                :label="item.name"
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          :disabled="!selected.length"
          @click="save"
        >
          Go!
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CacheSync',
  components: {},
  data() {
    return {
      loading: false,
      valid: false,
      drawer: false,
      saving: false,
      selected: []
    };
  },

  computed: {
    items() {
      return this.cache_keys.map((x) => ({ id: x.key, name: x.value }));
    },
    ...mapGetters({
      cache_keys: 'lookup/cache_keys'
    })
  },

  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.CACHE_SYNC_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.CACHE_SYNC_SHOW, () => {
      this.selected = [];
      this.drawer = true;
    });
  },

  methods: {
    save() {
      this.saving = true;
      this.$store
        .dispatch('lookup/syncCache', this.selected)
        .then(() => {
          this.$root.$snackbarSuccess('Cache synced');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
